import React from "react";
import toastr from "toastr";
import { Link } from "react-router-dom";

import { Constant } from "./Constant";
import { Validation } from "app/_helpers/validation/Validation";
import { NotificationManager } from "react-notifications";
import { SupportService } from "app/_services/Support/supportService";
import { CommmonService } from "app/_services/CommonService/CommonService";

import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import MultipleFileUpload from "app/views/custom/components/FileUpload/MultipleFileUpload";
import SimpleSelect from "app/Components/SearchableSelect/SimpleSelect";

class CreateTicket extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      error: {},
      projectId: this.props.match.params.id ? this.props.match.params.id : 1,
      projectData: {},
      section: "",
      subSection: "",
      module: "",
      Submodule: "",
      Priority: "",
      IssueSummary: "",
      IssueDescription: "",
      Attachments: "",
      fileId: [],
      submitted: false,
      sId: this.props.match.params.sId ? this.props.match.params.sId : "",
      dataModule: [],
      //subModules: "",
      subdataModule: [],
      selectedFileArray: [],
      isClosed: false,
      sectionListing: [
        {
          key: "Training Management",
          label: "Training Management",
        },
        {
          key: "OHSE Review",
          label: "OHSE Review",
        },
        {
          key: "Incident Management",
          label: "Incident Management",
        },
        // {
        //   key: "Project Settings",
        //   label: "Project Settings",
        // },
        {
          key: "CAPA Management",
          label: "CAPA Management",
        },
        {
          key: "Visible Felt Leadership",
          label: "Visible Felt Leadership",
        },
        {
          key: "Personnel Health Management",
          label: "Personnel Health Management",
        },
        {
          key: "Form A Management",
          label: "Form A Management",
        },
        // {
        //   key: "Project Home",
        //   label: "Project Home",
        // },
        // {
        //   key: " Project Dashboard",
        //   label: " ProjectDashboard",
        // },
        // {
        //   key: "configuration",
        //   label: "Configuration",
        // },
        // {
        //   key: "modules",
        //   label: "Modules",
        // },
        // {
        //   key: "Reports",
        //   label: "Reports",
        // },
        // {
        //   key: "Alarms",
        //   label: "Alarms",
        // },
      ],
      Training: [
        {
          key: "Schedule Training",
          label: "Schedule Training",
        },
        {
          key: "Training Status",
          label: "Training Status",
        },
        {
          key: "Training Batches",
          label: "Training Batches",
        },
        {
          key: "My Approval Actions",
          label: "My Approval Actions",
        },
        {
          key: "My Approval History",
          label: "My Approval History",
        },
        {
          key: "Calendar",
          label: "Calendar",
        },
      ],
      OHSE: [
        {
          key: " Schedule OHSE Review",
          label: " Schedule OHSE Review",
        },
        {
          key: "My Approval Actions",
          label: "My Approval Actions",
        },
        {
          key: "My Approval History",
          label: "My Approval History",
        },
        {
          key: "MY OHSE Review",
          label: "MY OHSE Review",
        },
        {
          key: "View OHSE Reviews",
          label: "View OHSE Reviews",
        },
        {
          key: "OHSE Review TASKS",
          label: "OHSE Review TASKS",
        },
        {
          key: "OHSE Review Calendar",
          label: "OHSE Review Calendar",
        },
      ],
      Incident: [
        {
          key: "Report Incident",
          label: "Report Incident",
        },
        {
          key: "My Incidents",
          label: "My Incidents",
        },
        {
          key: "View Incidents",
          label: "View Incidents",
        },
        {
          key: "My Approval Actions",
          label: "My Approval Actions",
        },
        {
          key: "My Approval History",
          label: "My Approval History",
        },
      ],
      CAPA: [
        {
          key: "Manage CAPA",
          label: "Manage CAPA",
        },
      ],
      Visible: [
        {
          key: "Schedule VFL",
          label: "Schedule VFL",
        },
        {
          key: "My VFLs",
          label: "My VFLs",
        },
        {
          key: "View VFLs",
          label: "View VFLs",
        },
        {
          key: "My Approval Actions",
          label: "My Approval Actions",
        },
        {
          key: "My Approval History",
          label: "My Approval History",
        },
        {
          key: "Calendar",
          label: "Calendar",
        },
      ],
      Personnel: [
        {
          key: "Medical Exam Due",
          label: "Medical Exam Due",
        },
        {
          key: "My Approval Actions",
          label: "My Approval Actions",
        },
        {
          key: "My Approval History",
          label: "My Approval History",
        },
        {
          key: "View Medical Data",
          label: "View Medical Data",
        },
      ],
      Form: [
        {
          key: "All Form A",
          label: "All Form A",
        },
        {
          key: "Completed Form A",
          label: "Completed Form A",
        },
        {
          key: "Pending Form A",
          label: "Pending Form A",
        },
      ],
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.checkValidation = this.checkValidation.bind(this);
    this.setProjectDetails = this.setProjectDetails.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onFileChange = this.onFileChange.bind(this);
    this.getSupportModule = this.getSupportModule.bind(this);
  }

  componentDidMount() {
    this.setProjectDetails();
    if (this.state.sId) {
      this.setSupportData(this.state.sId);
    }
  }

  async setProjectDetails() {
    // let response = await ProjectService.projectDetailsByID(this.state.projectId);
    // if (response && response.status) {
    //     if (response.data && response.data) {
    //         this.setState({
    //             projectData: response.data
    //         })
    //     }
    // }
  }

  async getSupportModule(e, getSubModuleArr) {
    let response = await SupportService.getSupportModule();
    if (response && response.status) {
      this.setState(
        {
          dataModule:
            response && response.data && response.data && response.data.section[e]
              ? response.data.section[e]
              : [],
          // subModules: response && response.data && response.data[e] ? response.data["sub" + capitalize(e)] : [],
        },
        () => {
          if (getSubModuleArr) {
            getSubModuleArr();
          }
        }
      );
    }
  }

  async setSupportData(id) {
    let response = await SupportService.getSupportByID(id);

    if (response && response.status) {
      let SupportData = response.data;
      if (response.data) {
        let selectedDocument = [];
        if (
          response.data.documents_table_mappings &&
          response.data.documents_table_mappings.length > 0
        ) {
          let documents_table_mappings = response.data.documents_table_mappings;

          documents_table_mappings.forEach((element) => {
            if (element.document) {
              selectedDocument.push(element.document);
            }
          });
        }

        this.setState(
          {
            section: SupportData.section,
            subSection: SupportData.subSection,
            module: SupportData.module_name,
            Submodule: SupportData.submodule_name,
            Priority: +SupportData.priority,
            IssueSummary: SupportData.issue_summary,
            IssueDescription: SupportData.issue_description,
            Attachments: "",
            fileId: [],
            edit: true,
            selectedFileArray: selectedDocument,
            isClosed: SupportData.isClosed == 1 ? true : false,
          },
          () => {
            this.getSupportModule(this.state.section, this.getSubModuleArr);
          }
        );
      }
    }
  }

  getSubModuleArr = () => {
    let moduleName = this.state.dataModule.slice();
    moduleName.map((data, index) => {
      if (data.label === this.state.module) {
        this.setState({
          subdataModule: data.subModule,
        });
      }
    });
  };

  handleInputChange = (e, dataName) => {
    const { name, value } = e.target;

    if (name === "section") {
      if (value === "") {
        this.setState((prev) => ({ ...prev, subSection: "" }));
      }
    }
    let moduleName = this.state.dataModule.slice();
    if (dataName === "label") {
      moduleName.map((data, index) => {
        if (data.label === e.target.value) {
          this.setState({
            subdataModule: data.subModule,
            Submodule: "",
          });
        }
      });
    }
    if (name === "section") {
      this.setState({
        Submodule: "",
        module: "",
      });
      // this.getSupportModule((value === "modules" || value === "configuration") ? "modules" : value)
      this.getSupportModule(value);
    }
    this.setState(
      {
        [name]: value,
      },
      () => {
        this.checkValidation();
        console.log("state", this.state);
      }
    );
  };

  onChangeHandler = (event, fileData) => {
    // var files = event.target.files
    // if (this.maxSelectFile(event)) {
    //     // if return true allow to setState
    //     this.setState({
    //         selectedFile: files
    //     })
    // }

    let selectedFileArray = this.state.selectedFileArray;

    this.setState({
      selectedFileArray: [...selectedFileArray, fileData],
    });
  };

  deleteDocumentFile = (e, fileIndex) => {
    e.preventDefault();

    let selectedFileArray = this.state.selectedFileArray;
    selectedFileArray.splice(fileIndex, 1);
    this.setState({
      selectedFileArray: selectedFileArray,
    });
  };

  checkValidation() {
    if (this.state.submitted) {
      var errobj = {};
      let Obj = { ...this.state, subSection: this.state.subSection.trim() };
      // errobj = Validation(this.state, Constant.Constants);
      errobj = Validation(Obj, Constant.Constants);
      this.setState({ error: errobj, submitted: true });
    }
  }

  async onFileChange(e) {
    const target = e.target;
    if (e.target.files[0]) {
      let selectedFile = e.target.files[0];
      if (selectedFile) {
        const formData = new FormData();
        formData.append("alias", this.state.Attachments);
        formData.append("file", selectedFile);
        let fileUploadResponse = await CommmonService.uploadDocument(formData);
        if (fileUploadResponse && fileUploadResponse.status) {
          let fileId = this.state.fileId.slice();
          this.setState({
            documentName: fileUploadResponse.data.real_document_name,
            fileId: fileId.concat(fileUploadResponse.data.id),
          });
        }
      }
    } else {
    }
    target.value = null;
  }

  async onSubmit(e) {
    //  e.preventDefault();
    if (this.state.projectId) {
      var errobj = {};
      var flag = 0;
      const Activity = Constant.Activity;
      let stateObj = { ...this.state, subSection: this.state.subSection.trim() };
      //errobj = Validation(this.state, Constant.Constants);
      errobj = Validation(stateObj, Constant.Constants); // changesByAnmolLatiyan

      this.setState({ error: errobj, submitted: true });
      Object.keys(errobj).map((index) => {
        if (errobj[index] !== "") {
          flag = 1;
        }
      });
      if (flag === 0) {
        let document_id = [];

        if (this.state.selectedFileArray) {
          let selectedFileArray = this.state.selectedFileArray;
          selectedFileArray.forEach((document) => {
            document_id.push(document.id);
          });
        }

        let obj = {
          // "project_id": 1,
          // "ticket_no": 1,
          // "ticket_date": 1,
          section: this.state.section,
          subSection: this.state.subSection.trim(), //anmolLatiyan
          module_name: this.state.module,
          submodule_name: this.state.Submodule,
          //"reported_by": 1,
          priority: this.state.Priority,
          issue_summary: this.state.IssueSummary,
          issue_description: this.state.IssueDescription,
          documents: document_id,
        };
        let data = {};
        if (this.state.edit) {
          data = await SupportService.updateSupport(this.state.sId, obj);
        } else {
          obj.urlFrom = localStorage.getItem("urlFrom");
          data = await SupportService.createSupport(obj);
        }
        if (data) {
          if (this.state.edit) {
            toastr.success("Data Updated!");
            this.props.history.push("/support");
          } else {
            toastr.success("Data Created!");
            localStorage.removeItem("urlFrom");
            this.props.history.push("/support");
          }
        } else if (data && data.message) {
          NotificationManager.warning(data.message);
        }
      }
    }
  }

  render() {
    const {
      section,
      subSection,
      module,
      Submodule,
      Priority,
      IssueSummary,
      IssueDescription,
      Attachments,
      selectedFileArray,
      submitted,
      isClosed,
      edit,
    } = this.state;
    let sectionName = "";
    {
      section != "" && (sectionName = section.split(" ")[0]);
    }
    return (
      <div>
        <MainBreadcrumb
          routeSegments={[
            { name: "Support", path: "/support" },
            { name: edit ? "Update Ticket" : "Create Ticket" },
          ]}
          breadCrumbsText="Support"
        />
        <div className="row d-flex justify-content-center">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                <div className="simple-card-title">
                  <h3 class="text-capitalize mb-1">
                    {this.state.edit ? "Update" : "Create"} Ticket
                  </h3>
                </div>
                <>
                  <div className="row">
                    <div className="col-md-4 form-group mb-3">
                      <label>Section</label>

                      <SimpleSelect
                        name="section"
                        className="form-control"
                        value={section}
                        onChange={(e) => this.handleInputChange(e)}
                        disabled={isClosed}
                        id="key"
                        label="label"
                        options={this.state.sectionListing}
                        init="Select Section"
                      ></SimpleSelect>
                      {this.state.submitted && this.state.error.section !== "" && (
                        <div className="fromerror">{this.state.error.section}</div>
                      )}
                    </div>
                    <div className="col-md-4 form-group mb-3">
                      <label>Sub Section</label>

                      <SimpleSelect
                        name="subSection"
                        className="form-control"
                        value={subSection}
                        onChange={(e) => this.handleInputChange(e)}
                        disabled={isClosed || section === ""}
                        id="key"
                        label="label"
                        options={this.state[sectionName]}
                        init="Select Sub Section"
                      ></SimpleSelect>
                      {this.state.submitted && this.state.error.subSection !== "" && (
                        <div className="fromerror">{this.state.error.subSection}</div>
                      )}
                    </div>
                    {/* <div className="col-md-4 form-group mb-3">
                      <label>Module</label>

                      <SimpleSelect
                        name="module"
                        className="form-control"
                        value={module}
                          
                        onChange={(e) => this.handleInputChange(e, "label")}
                        disabled={isClosed}
                        disabled={
                          this.state.dataModule.length === 0 ? true : false
                        }
                        id="label"
                        label="label"
                        options={this.state.dataModule}
                        init="Select Module"
                      ></SimpleSelect>

                      {this.state.submitted &&
                        this.state.error.module !== "" && (
                          <div className="fromerror">
                            {this.state.error.module}
                          </div>
                        )}
                          
                    </div>

                    <div className="col-md-4 form-group mb-3">
                      <label>Sub Module</label>

                      <SimpleSelect
                        name="Submodule"
                        className="form-control"
                        value={Submodule}
                        onChange={(e) => this.handleInputChange(e)}
                        disabled={
                          this.state.dataModule.length === 0 ||
                          this.state.subdataModule.length === 0
                            ? true
                            : false
                        }
                        id="label"
                        label="label"
                        options={this.state.subdatasectionNameModule}
                        init="Select"
                      ></SimpleSelect>

                      {this.state.submitted &&
                          
                        this.state.error.Submodule !== "" && (
                          <div className="fromerror">
                            {this.state.error.Submodule}
                          </div>
                        )}
                    </div> */}
                    <div className="col-md-4 form-group mb-3">
                      <label>Priority</label>
                      {/* <select
                                                name="Priority"
                                                className="form-control"
                                                value={Priority}
                                                onChange={e => this.handleInputChange(e)}
                                                disabled={isClosed}
                                                >sectionName
                                                <option value="">Select</option>
                                                <option value={1}>Low</option>
                                                <option value={2}>Medium</option>
                                  sectionName              <option value={3}>High</option>
                                            </select> */}

                      <SimpleSelect
                        name="Priority"
                        className="form-control"
                        value={Priority}
                        onChange={(e) => this.handleInputChange(e)}
                        disabled={isClosed}
                        id="id"
                        label="name"
                        options={[
                          { id: 1, name: "Low" },
                          { id: 2, name: "Medium" },
                          { id: 3, name: "High" },
                        ]}
                        init="Select Priority"
                      ></SimpleSelect>
                      {this.state.submitted && this.state.error.Priority !== "" && (
                        <div className="fromerror">{this.state.error.Priority}</div>
                      )}
                    </div>
                    <div className="col-md-12 form-group mb-3">
                      <label>Issue Summary</label>
                      <textarea
                        name="IssueSummary"
                        value={IssueSummary}
                        onChange={(e) => this.handleInputChange(e)}
                        maxlength="250"
                        readOnly={isClosed}
                        placeholder="Issue Summary"
                        className="form-control"
                      ></textarea>
                      {this.state.submitted && this.state.error.IssueSummary !== "" && (
                        <div className="fromerror">{this.state.error.IssueSummary}</div>
                      )}
                    </div>

                    <div className="col-md-12 form-group mb-3">
                      <label>Issue Section Name Description</label>
                      <textarea
                        name="IssueDescription"
                        value={IssueDescription}
                        onChange={(e) => this.handleInputChange(e)}
                        placeholder="Issue Description"
                        className="form-control"
                        maxlength="250"
                        readOnly={isClosed}
                      ></textarea>
                      {this.state.submitted &&
                        this.state.error.IssueDescription !== "" && (
                          <div className="fromerror">
                            {this.state.error.IssueDescription}
                          </div>
                        )}
                    </div>

                    {!isClosed && (
                      <MultipleFileUpload
                        selectedFileArray={selectedFileArray}
                        onFileChange={this.onChangeHandler}
                        submitted={submitted}
                        uploadLimit={3}
                        labelName={"Attachments"}
                        deleteDocumentFile={this.deleteDocumentFile}
                      ></MultipleFileUpload>
                    )}
                    <div className="col-md-12 pt-2"></div>
                    <div className="col-md-12 text-center">
                      <Link to={"/support"} className="btn btn-secondary mr-2">
                        Back
                      </Link>
                      <button
                        className="btn btn-primary ml-2"
                        onClick={() => this.onSubmit()}
                      >
                        {this.state.edit ? "Update" : "Submit"}
                      </button>
                    </div>
                  </div>
                </>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CreateTicket;

let capitalize = function (e) {
  if (e !== "") {
    return e.charAt(0).toUpperCase() + e.slice(1);
  } else {
    return "";
  }
};
